import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { useHistory, useParams, useRouteMatch, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import {
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  UncontrolledDropdown,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import clsx from 'clsx';
import styled from 'styled-components';

import Title from '../components/Title';
import Table from '../components/Table';
import ConfirmationModal from '../components/ConfirmationModal';
import bootbox from '../components/Bootbox';
// import Avatar from "../components/Avatar";
import Button from '../components/Button';
import { SearchInput } from '../components/SearchInput';
import UploadPdfModal from '../components/UploadPdfModal';
import { useModalsState } from '../context/modals';
import { useProfile } from '../api/hooks/profile';
import useDebounce from '../hooks/useDebounce';
import useWhoami from '../hooks/useWhoami';
import {
  useContractList,
  useContractAction,
  useResendContract,
  useSendContract,
} from '../api/hooks/contracts';
import useQueryParams from '../hooks/useQuery';
import { ReactComponent as DocuAgregarIcon } from '../images/Docu_agregar.svg';
import IApreviewModal from '../components/IaAnalysisPreviewModal';
import {
  truncate,
  downloadFile,
  getInitialLetters,
  getDisplayName,
} from '../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';

function ContractsTableContainer({ className }) {
  const { t } = useTranslation('common');
  const { templateId } = useParams();
  const query = useQueryParams();
  const matched = useRouteMatch();
  const history = useHistory();
  const modalsState = useModalsState();
  const { can } = useProfile();
  const [currentPage, setCurrentPage] = useState(1);
  const [isResendOpen, setIsResendOpen] = useState(false);
  const [search, setSearch] = useState(query.get('search') ?? '');
  const [resendData, setResendData] = useState({});
  const [isShield3ValidationOpen, setIsShield3ValidationOpen] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [currentContract, setCurrentContract] = useState({});
  const debouncedSearch = useDebounce(search, 500);
  const { getWhoamiFor } = useWhoami();
  const queryClient = useQueryClient();

  const isTemplateDocuments = !!templateId;
  const params = useMemo(
    () => ({
      page: currentPage,
      perPage: 8,
      search: debouncedSearch,
      templateId,
    }),
    [currentPage, debouncedSearch, templateId]
  );

  const { isLoading, isFetching, data = {}, error } = useContractList(params);
  const { mutate: doContractAction } = useContractAction();
  const hasData = !!data?.data?.length;
  const { mutate: sendContractMutation, isLoading: sending } =
    useSendContract();

  const handleSearch = (evt) => {
    const value = evt?.target?.value ?? '';
    setCurrentPage(1);
    setSearch(value);
    history.replace(`${matched.url}?search=${value}`);
  };

  const goBack = () => {
    history.goBack();
  };

  const handleDownloadNom151 = (document) => {
    return downloadFile({
      name: document.name,
      url: document.nom151,
      suffix: 'NOM-151',
    });
  };

  useEffect(() => {
    console.log(data);
  }, [data]);

  const handleDownloadDocument = (document) => {
    if (document.nom151)
      downloadFile({
        name: document.name,
        suffix: 'NOM-151',
        url: document.nom151,
      })();
    if (document.nom151Bin)
      downloadFile({
        name: document.name,
        suffix: 'NOM-151',
        ext: 'der',
        url: document.nom151Bin,
      })();
    downloadFile({ name: document.name, url: document.importedPdf })();
  };

  const handleSendContract = async (contract) => {
    sendContractMutation({ _id: contract._id });
  };

  const handleNextPage = () => {
    const newPage = Math.min(currentPage + 1, data.numPages);
    setCurrentPage(newPage);
  };

  const handlePrevPage = () => {
    const newPage = Math.max(currentPage - 1, 1);
    setCurrentPage(newPage);
  };

  const handleEditDocument = (doc) => {
    history.push(`/documents/${doc._id}/edit`);
  };

  const handleResetList = () => {
    history.push(`/documents`);
  };

  const handleDeleteDocument = async (doc) => {
    const confirm = await bootbox.confirm(t('delete_confirm'));
    if (!confirm) return;

    doContractAction(
      { contractId: doc._id, action: 'remove' },
      {
        onSuccess: (actionResult) => {
          if (actionResult?.success) {
            toast.success(t('El documento fue eliminado con éxito'));
            queryClient.invalidateQueries('contracts');
            // onUpdateContract(payload)
          }
        },
      }
    );
  };

  const handleCancelDocument = async (doc) => {
    const cancelReason = await bootbox.prompt(t('cancel_confirm_prompt'));
    if (cancelReason === null) return;
    doContractAction(
      { contractId: doc._id, action: 'cancel', cancelReason },
      {
        onSuccess: (actionResult) => {
          if (actionResult?.success) {
            toast.success(t('El documento fue cancelado con éxito'));
            queryClient.invalidateQueries('contracts');
          }
        },
      }
    );
  };
  const handleValidateShield3Video = (doc) => {
    setCurrentContract(doc || {});
    setIsShield3ValidationOpen(!isShield3ValidationOpen);
  };
  const [Iamodal, setIamodal] = useState(false);
  const [Iamodalanalysis, setIamodalanalysis] = useState({});
  const handleIAPreview = (analysis) => {
    setIamodalanalysis(analysis);
    setIamodal(true);
  };
  return (
    <div className={className}>
      <Title
        className="mb-4"
        // button
        // search
        searchProps={{
          label: t('forms.search'),
          onChange: handleSearch,
          value: search,
        }}
      >
        {/* { isTemplateDocuments ? (<>
              <span className="text-dark cursor-pointer" onClick={goBack}>{t('myTemplates')}</span>{' '}
              <span className="text-muted">/ {truncate(modalsState?.template?.name ?? data?.template?.name, 25)} </span>
            </>) : ( */}
        <IApreviewModal
          isOpen={Iamodal}
          analysis={Iamodalanalysis}
          toggle={() => setIamodal(false)}
        />
        <div className="d-flex justify-content-end">
          {/* <div>
               <span className="text-dark cursor-pointer">{t('myDocuments')}</span>
              </div> */}
          <div className="d-flex">
            {!isLoading && isTemplateDocuments && (
              <div
                className="bg-primary text-light rounded p-2 ws-nowrap mr-2"
                style={{ fontSize: '12px' }}
              >
                <span className="">
                  {truncate(
                    modalsState?.template?.name ?? data?.template?.name,
                    25
                  )}
                </span>
                <span className="ml-2 pointer" onClick={handleResetList}>
                  x
                </span>
              </div>
            )}
            {hasData && (
              <SearchInput
                placeholder={t('forms.search')}
                className={`form-control align-self-center `}
                value={search}
                onChange={handleSearch}
              />
            )}
            <UploadPdfModal
              buttonProps={{
                className: 'text-no-wrap ml-2',
                size: 'sm',
                color: 'accent-100',
              }}
            >
              {t('actions.uploadDocument')}
            </UploadPdfModal>
          </div>
        </div>

        {/* ) } */}
      </Title>
      {hasData || isLoading ? (
        <Table
          paginationData={data}
          onNextPage={handleNextPage}
          onPrevPage={handlePrevPage}
          isLoading={isLoading || isFetching}
          hasError={error}
          EmptyTableProps={{
            primary: t('noDocuments'),
            secondary: t('noResults'),
          }}
          columns={[
            {
              header: 'ID',
              key: 'documentId',
            },
            {
              header: t('createdAt'),
              key: 'createdAt',
              className: 'text-nowrap',
              render: (contract) => {
                return (
                  <span className="text-black-50">
                    {format(new Date(contract.createdAt), 'dd-MM-yyyy')}
                  </span>
                );
              },
            },
            {
              header: t('document'),
              key: 'name',
              render: (contract) => {
                return <span className="text-black-50">{contract.name}</span>;
              },
            },
            {
              header: t('status'),
              key: 'status',
              render: (contract) => {
                return <StatusText contract={contract} />;
              },
            },
            {
              header: t('shieldType'),
              key: 'shield',
              className: 'text-center',
              render: (contract) => {
                // const hasAcceptedVideo = ;
                return (
                  <span className="p-2 rounded bg-grey">
                    {t('shield', { context: 'short', number: contract.shield })}
                  </span>
                );
              },
            },
            {
              header: t('IA'),

              className: 'text-center',
              render: (contract) => {
                return (
                  <div>
                    {contract?.iaAnalysis ? (
                      <span
                        style={{
                          textDecoration: 'underline',
                          color: '#f37b33',
                        }}
                        onClick={() => handleIAPreview(contract?.iaAnalysis)}
                      >
                        ANÁLISIS
                      </span>
                    ) : (
                      <span></span>
                    )}
                  </div>
                );
              },
            },
            {
              header: t('participant', { count: 2 }),
              key: 'participants',
              // className: 'text-center',
              render: (contract) => {
                return <ParticipantAvatarList contract={contract} />;
              },
            },
          ]}
          data={data?.data}
          actions={[
            {
              key: 'nom151',
              icon: 'file-signature',
              isLink: false,
              onClick: handleDownloadNom151,
              shouldHide: (doc, action) => {
                return true;
                // return !doc.nom151
              },
              label: t('actions.download', { context: 'nom151' }),
            },
            {
              key: 'importedPdf',
              icon: 'cloud-download-alt',
              isLink: false,
              onClick: handleDownloadDocument,
              shouldHide: (doc, action) => {
                if (doc.status !== 'RECEIVED_SIGNED') return true;
                return !!doc.dropboxUrl;
              },
              label: `${t('actions.download')} ${t('document')}`,
            },
            {
              key: 'dropboxUrl',
              icon: 'cloud-download-alt',
              isLink: true,
              shouldShow: (doc, action) => {
                return !!doc.dropboxUrl;
              },
              label: t('actions.viewOn', { service: 'Dropbox' }),
            },
            {
              key: 'documentId',
              icon: 'paper-plane',
              isLink: false,
              shouldShow: (doc, action) => {
                return false;
                return doc.status === '' || doc.status === 'DRAFT';
              },
              onClick: handleSendContract,
              label: 'Enviar',
            },
            {
              className: 'text-sm',
              key: 'documentId',
              icon: 'edit',
              shouldShowPremiumIcon: (doc, action) => {
                if (['', 'DRAFT'].includes(doc.status)) return false;
                return !can('EDIT_SENT_DOCUMENT');
              },
              onClick: handleEditDocument,
              label: 'Editar',
            },
            {
              key: 'url',
              icon: 'external-link-alt',
              isLink: true,
              shouldHide: (doc, action) => {
                return ['', 'DRAFT'].includes(doc.status);
              },
              label: t('actions.viewDocument'),
            },
            {
              className: 'text-sm',
              key: 'documentId',
              icon: 'trash',
              shouldShow: (doc, action) => {
                return (
                  ['DRAFT', ''].includes(doc.status) && can('DELETE_DOCUMENT')
                );
              },
              shouldShowPremiumIcon: (doc, action) => {
                return !can('DELETE_DOCUMENT');
              },
              onClick: handleDeleteDocument,
              label: 'Eliminar',
            },
            {
              className: 'text-sm',
              key: 'documentId',
              icon: 'ban',
              shouldShow: (doc, action) => {
                const whoami = getWhoamiFor(doc);
                if (whoami.isSigned()) return false;
                if (whoami.isFinalized()) return false;
                if (whoami.isArchived()) return false;
                if (whoami.isCanceled()) return false;
                if (!whoami.isOwner()) return false;
                if (whoami.isFolder()) return false;
                return true || can('CANCEL_DOCUMENT');
              },
              shouldShowPremiumIcon: (doc, action) => {
                return !can('CANCEL_DOCUMENT');
              },
              onClick: handleCancelDocument,
              label: 'Cancelar',
            },
            {
              className: 'text-sm',
              key: 'documentId',
              icon: 'video',
              shouldShow: (doc, action) => {
                const whoami = getWhoamiFor(doc);
                if (!whoami.hasShield3()) return false;
                if (!whoami.hasShield3Video()) return false;
                return true;
              },
              onClick: handleValidateShield3Video,
              label: 'Ver Blindaje 3',
            },
          ]}
        />
      ) : (
        <div className="d-flex flex-column justify-content-center align-items-center w-100 mb-4">
          <DocuAgregarIcon className="mb-2" />
          <div className="font-size-32 font-weight-bold text-center">
            Firma tu primer contrato digital
          </div>
          <div className="font-size-32 font-weight-bold">
            Sube un{' '}
            <span className="text-underline text-accent">Documento</span> o
            utiliza una{' '}
            <Link className="text-underline" to="/templates/own">
              Plantilla
            </Link>
          </div>
        </div>
      )}
      <ValidateShield3Modal
        isOpen={isShield3ValidationOpen}
        toggle={handleValidateShield3Video}
        participants={currentContract?.participants}
        shield3ValidationRequired={currentContract?.shield3ValidationRequired}
        contractId={currentContract?._id}
      />
    </div>
  );
}

export default ContractsTableContainer;

function Question({ question, participantName }) {
  return (
    <span className="px-1">
      {question}
      <strong className="text-capitalize font-weight-bolder">
        {participantName}
      </strong>
      {'?'}
    </span>
  );
}

export function StatusText({ contract }) {
  const { t } = useTranslation();
  const { backgroundColor, borderColor, color, border } = getColors(
    contract.status
  );

  return (
    <div
      className={`p-1 font-size-14 text-nowrap rounded text-center`}
      style={{ backgroundColor, borderColor, color, border }}
    >
      {t(`documentStatus.${contract.status ? contract.status : 'DRAFT'}`)}
    </div>
  );
}
const MAX_NUMBER_OF_PARTICIPANTS = 4;

export function ParticipantAvatarList({ contract }) {
  const { t } = useTranslation();
  const [isResendOpen, setIsResendOpen] = useState(false);
  const [resendData, setResendData] = useState({});

  const [participants, participantsInMenu, participantsLength] = useMemo(() => {
    const parts = contract.participants
      .map((p, i) => ({ ...p, index: i + 1 }))
      .filter((p) => {
        if (contract.status === 'NEGOTIATION') return !p.isNotNegotiator;
        if (['SENT_TO_SIGN'].includes(contract.status)) return !p.isNotSigner;
        return true;
      });
    return [
      parts.slice(0, MAX_NUMBER_OF_PARTICIPANTS),
      parts.slice(MAX_NUMBER_OF_PARTICIPANTS),
      parts.length,
    ];
  }, [contract.participants, contract.status]);

  const { mutate: resendContractToParticipantMutation, isLoading: resending } =
    useResendContract({
      onSuccess: () => {
        setIsResendOpen(false);
      },
    });

  const toggleResend = (contract, participant) => {
    if (!['FINALIZED', 'RECEIVED_SIGNED', ''].includes(contract.status)) {
      setIsResendOpen((isOpen) => !isOpen);
      setResendData({
        participantName: getDisplayName(
          participant.name,
          participant.last_name
        ),
        participantId: participant._id,
        contractId: contract._id,
      });
    }
  };

  const handleResendEmail = async () => {
    resendContractToParticipantMutation({
      participantId: resendData.participantId,
      contractId: resendData.contractId,
      participantName: resendData.participantName,
    });
  };

  return (
    <div className="d-flex">
      {participants.map((participant, i) => {
        return (
          <ParticipantAvatar
            className="mb-1"
            contract={contract}
            participant={participant}
            index={participant.index}
            showShield3Status={contract.shield3ValidationRequired}
            onClick={toggleResend}
          />
        );
      })}
      {participantsLength > MAX_NUMBER_OF_PARTICIPANTS && (
        <UncontrolledDropdown>
          <DropdownToggle tag="div" className="d-inline-flex">
            <Avatar
              className={'align-self-center align-middle p-3 mr-1'}
              backgroundColor={'#ccc'}
              borderColor={'#ccc'}
              color={'black'}
            >
              <small>
                <b>
                  {contract.participants.length - MAX_NUMBER_OF_PARTICIPANTS}
                  <strong>+</strong>
                </b>
              </small>
            </Avatar>
          </DropdownToggle>
          <DropdownMenu className="p-2" style={{ maxWidth: 110 }}>
            <div className="d-flex flex-wrap m-1 justify-content-center align-items-center">
              {participantsInMenu.map((participant, i) => (
                <ParticipantAvatar
                  className="mb-1"
                  contract={contract}
                  participant={participant}
                  index={participant.index}
                  onClick={toggleResend}
                />
              ))}
            </div>
          </DropdownMenu>
        </UncontrolledDropdown>
      )}
      <ConfirmationModal
        onCancel={() => toggleResend({}, {})}
        isOpen={isResendOpen}
        isLoading={resending}
        onConfirm={handleResendEmail}
        confirmText={t('actions.resend')}
        cancelText={t('actions.cancel')}
        QuestionComponent={Question}
        QuestionComponentProps={{
          question: t('resendQuestion'),
          participantName: resendData.participantName,
        }}
        simple
      />
    </div>
  );
}

const Avatar = styled.div`
  text-align: center;
  border-radius: 50%;
  border: 1px solid;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  background-color: ${(props) => props.backgroundColor};
  border-color: ${(props) => props.borderColor};
  color: ${(props) => props.color};
`;

function ValidateShield3Modal({
  isOpen,
  toggle,
  participants,
  shield3ValidationRequired,
  contractId,
}) {
  const initialParticipant = useMemo(() => {
    return participants?.find((p) => p.requestAgreement);
  }, [participants]);
  const queryClient = useQueryClient();
  // const participant = participants?.find((p) => p.requestAgreement) || {};
  const participantsWithShield3 = useMemo(() => {
    return participants
      ?.filter((p) => p.requestAgreement)
      .map((p) => ({
        label: `${p.label} (${p.email})`,
        value: p._id,
        ...p,
      }));
  }, [participants]);
  const [currentParticipant, setCurrentParticipant] = useState({});
  const { mutate: doContractAction } = useContractAction();

  useEffect(() => {
    if (initialParticipant) {
      setCurrentParticipant({
        label: `${initialParticipant?.label || ''} (${
          initialParticipant?.email || ''
        })`,
        value: initialParticipant._id,
        ...initialParticipant,
      });
    }
  }, [initialParticipant]);

  const handleAcceptVideo = () => {
    doContractAction(
      {
        contractId,
        action: 'validateparticipantvideo',
        participantId: currentParticipant.value,
      },
      {
        onSuccess: (actionResult) => {
          toast.success('El video fue validado con éxito');
          queryClient.invalidateQueries('contracts');
          toggle({});
        },
      }
    );
  };
  const handleRejectVideo = () => {
    doContractAction(
      {
        contractId,
        action: 'rejectparticipantvideo',
        participantId: currentParticipant.value,
      },
      {
        onSuccess: (actionResult) => {
          toast.success('El video fue rechazado con éxito');
          queryClient.invalidateQueries('contracts');
          toggle({});
        },
      }
    );
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Validar video de Consetimiento</ModalHeader>
      <ModalBody>
        <div className="mb-2">
          <Select
            value={currentParticipant}
            options={participantsWithShield3}
            onChange={(option) => setCurrentParticipant(option)}
          />
        </div>
        {currentParticipant.video ? (
          <Shield3Video src={currentParticipant.video}></Shield3Video>
        ) : (
          <div>Este participante no ha grabado su video</div>
        )}
        <div
          className="text-center  mt-3"
          hidden={
            currentParticipant.videoStatus !== 'validating' ||
            !shield3ValidationRequired
          }
        >
          <Button color="success" onClick={handleAcceptVideo}>
            Aceptar
          </Button>
          <Button className="ml-4" color="danger" onClick={handleRejectVideo}>
            Rechazar
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}
function Shield3Video({ src }) {
  const videoRef = useRef();

  useEffect(() => {
    videoRef.current?.load();
  }, [src]);

  return (
    <video controls className="w-100 rounded" ref={videoRef}>
      <source src={src} type="video/webm" />
    </video>
  );
}

function Shield3StatusIcon({ participant }) {
  const shield3Properties = useMemo(() => {
    if (participant.videoValidated) {
      return {
        icon: 'check-circle',
        color: 'green',
        tooltip: 'Video validado',
      };
    } else if (participant.videoStatus === 'rejected') {
      return {
        icon: 'exclamation-circle',
        color: 'red',
        tooltip: 'Video rechazado',
      };
    } else if (participant.videoStatus === 'validating') {
      return {
        icon: 'exclamation-triangle',
        color: '#f29921',
        tooltip: 'Video pendiente de validacion',
      };
    }
    return;
  }, [participant.videoValidated, participant.videoStatus]);

  if (!participant.requestAgreement || !shield3Properties) return null;

  return (
    <FontAwesomeIcon
      className="position-absolute"
      icon={shield3Properties.icon}
      style={{
        bottom: -5,
        right: -6,
        color: shield3Properties.color,
      }}
    />
  );
}

const ParticipantAvatar = ({
  className,
  contract,
  participant,
  index,
  showShield3Status,
  onClick,
}) => {
  const { t } = useTranslation();
  const { backgroundColor, borderColor, color } = getColors(participant.status);
  const handleClick = () => {
    onClick(contract, participant);
  };

  return (
    <div className={clsx('d-inline-flex', className)}>
      <Avatar
        id={`participant-${participant._id}-${contract?._id}`}
        className={'align-self-center align-middle p-2 mr-1 position-relative'}
        backgroundColor={backgroundColor}
        borderColor={borderColor}
        color={color}
        onClick={handleClick}
      >
        {showShield3Status && <Shield3StatusIcon participant={participant} />}
        <small>
          <b>
            {getInitialLetters(participant.name, participant.last_name) ||
              `P${index}`}
          </b>
          {/* {icon && <i className="fas fa-user-plus"></i>} */}
        </small>
      </Avatar>
      <UncontrolledTooltip
        target={`participant-${participant._id}-${contract?._id}`}
      >
        <div className="text-capitalize">
          {participant.name} {participant.last_name}
        </div>
        <div>{t(`documentStatus.${participant.status ?? ''}`, '')}</div>
        <div hidden={!showShield3Status}>
          {participant.videoValidated
            ? 'Video de Consentimiento Validado'
            : participant.videoStatus === 'validating'
            ? 'Video de Consentimiento Pendiente de Validación'
            : participant.videoStatus === 'rejected'
            ? 'Video  de Consentimiento Rechazado'
            : null}
        </div>
      </UncontrolledTooltip>
    </div>
  );
};

const getColors = (status) => {
  // ACCEPTED_NEGOTIATION = 'ACCEPTED_NEGOTIATION',
  // NEGOTIATION_TAKEN = 'NEGOTIATION_TAKEN',
  // PENDING_NEGOTIATION = 'PENDING_NEGOTIATION', #F47B33
  switch (status) {
    case 'NEGOTIATION_TAKEN':
      return {
        backgroundColor: 'white',
        borderColor: '#f8ca05',
        color: 'black',
        border: '1px solid #f8ca05',
      };
    case 'PENDING_NEGOTIATION':
    case 'NEGOTIATION':
      return {
        backgroundColor: 'white',
        borderColor: '#393d42',
        color: 'black',
        border: '1px solid #393d42',
      };
    case 'ACCEPTED_NEGOTIATION':
      return {
        backgroundColor: 'white',
        borderColor: '#2ab700',
        color: 'black',
        border: '1px solid #2ab700',
      };
    case 'RECEIVED_TO_SIGN':
    case 'RECEIVED_TO_FILL':
    case 'SENT_TO_SIGN':
    case 'SENT_TO_FILL':
      return {
        backgroundColor: '#f8ca05',
        borderColor: '#f8ca05',
        color: 'white',
      };
    // case 'EXPIRED':
    //     return { backgroundColor: 'red', borderColor: 'red', color: 'white' }
    case 'SENT_FILLED':
    case 'RECEIVED_SIGNED':
    case 'SENT_SIGNED':
    case 'RECEIVED_TO_DOWNLOAD':
    case 'FINALIZED':
    case 'SENT_TO_DOWNLOAD':
      return {
        backgroundColor: '#2ab700',
        borderColor: '#2ab700',
        color: 'white',
      };
    default:
      return {
        backgroundColor: '#D8D8D8',
        borderColor: '#D8D8D8',
        color: '#9F9F9F',
      };
  }
};
